module.exports = __webpack_public_path__ + "static/img/ledis-logo.e24f51e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ledis-logo.png
// module id = hrUv
// module chunks = 2